import { render } from "./WelcomeLayout.vue?vue&type=template&id=bd6efcf8&scoped=true"
import script from "./WelcomeLayout.vue?vue&type=script&lang=js"
export * from "./WelcomeLayout.vue?vue&type=script&lang=js"

import "./WelcomeLayout.vue?vue&type=style&index=0&id=bd6efcf8&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/epr-survey-builder/Vue_Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd6efcf8"]])

export default __exports__